<template>
<div>
    <!-- table -->
    <vue-good-table id="jobCountReportTable" ref="jobCountReportTable" :columns="columns" styleClass="vgt-table condensed tableSize" :rows="rows" hide-footer :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: false,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'countOfObjectionToUs'" class="text-nowrap">
                {{ $t('jobCountReport.count_of_objection_to_us') }}
            </span>
            <span v-else-if="props.column.field === 'countOfObjectionToDecision'" class="text-nowrap">
                {{ $t('jobCountReport.count_of_objection_to_decision') }}
            </span>
            <span v-else-if="props.column.field === 'countOfPriorityRights'" class="text-nowrap">
                {{ $t('jobCountReport.count_of_priority_rights') }}
            </span>
            <span v-else-if="props.column.field === 'countOfLackDecision'">
                {{ $t('jobCountReport.count_of_lack_decision') }}
            </span>
        </template>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'countOfObjectionToUs'">
                <span>
                    {{ props.row.countOfObjectionToUs }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'countOfObjectionToDecision'">
                <span>
                    {{ props.row.countOfObjectionToDecision }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'countOfPriorityRights'">
                <span>
                    {{ props.row.countOfPriorityRights }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'countOfLackDecision'">
                <span>
                    {{ props.row.countOfLackDecision }}
                </span>
            </span>
        </template>
        <!-- Column: Table Column -->
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        recordId: Number,
        moduleId: Number
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('jobCountReport.count_of_objection_to_us'),
                    field: 'countOfObjectionToUs',
                },
                {
                    label: this.$t('jobCountReport.count_of_objection_to_decision'),
                    field: 'countOfObjectionToDecision',
                },
                {
                    label: this.$t('jobCountReport.count_of_priority_rights'),
                    field: 'countOfPriorityRights',
                },
                {
                    label: this.$t('jobCountReport.count_of_lack_decision'),
                    field: 'countOfLackDecision'
                },
            ],
            searchTerm: '',
            rows: [],
            jobCountReportForTrademark: [],
        }
    },
    mounted() {
        this.getjobCountReportList()
    },
    methods: {
        getjobCountReportList() {
            const controller = {
                name: 'Job',
                actionName: 'GetJobCountReportOfRecord'
            }
            const data = {
                recordId: this.recordId,
                moduleId: this.moduleId
            }
            const payload = {
                controller: controller,
                data: data
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows.push(response.data.jobCountReportForTrademark)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
